import * as Redux from 'redux'
import * as Modal from '../../components/modal'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

const modalReducerEvent: Modal.ReducerEvent<Types.UserKeyModalData> = {
  initializeState: () => Constants.emptyAddUserKeyModalState,
  requestEvent: Constants.ADD_USER_KEY,
}

const reducerEvent: Sortable.ReducerEvent<Types.UserSettings> = {
  requestEvent: Constants.FETCH_USER_SETTINGS,
}

const dataReducer = (state: Types.UserSettings = Constants.emptyViewState, action: any) => {
  switch (action.type) {
    case Request.successConstant(Constants.FETCH_USER_SETTINGS):
      return action.payload.response
    default:
      return state
  }
}

export const reducer = Redux.combineReducers({
  data: dataReducer,
  modal: Modal.reducer(modalReducerEvent),
  view: Sortable.viewReducer(reducerEvent),
})



// WEBPACK FOOTER //
// ./src/pages/user-settings/reducer.ts